import { type SalesFunnelStep } from "@fitness-app/data-models/entities/SalesFunnel";

/**
 * Copies a funnel's steps under fresh ids. Sessions and stats are keyed by step id, so a copy
 * sharing them with its source would mix both funnels. Upsell/downsell "next step" links are
 * pointed at the copies of the steps they pointed at.
 */
export const duplicateSalesFunnelSteps = (
  steps: SalesFunnelStep[],
  createId: () => string = () => crypto.randomUUID(),
): SalesFunnelStep[] => {
  const newIds = new Map(steps.map((step) => [step.id, createId()]));
  const remap = (id: string | undefined) => (id ? (newIds.get(id) ?? id) : id);
  const now = new Date().toISOString();

  return steps.map((step) => {
    const copy = structuredClone(step);
    copy.id = newIds.get(step.id)!;
    copy.createdAt = now;
    copy.updatedAt = now;

    if ("offerAcceptedNextStepId" in copy.stepConfig) {
      copy.stepConfig.offerAcceptedNextStepId = remap(copy.stepConfig.offerAcceptedNextStepId) ?? "";
      copy.stepConfig.offerRejectedNextStepId = remap(copy.stepConfig.offerRejectedNextStepId) ?? "";
    }

    return copy;
  });
};
